module.exports = __webpack_public_path__ + "static/media/n_icon_dynameic.63b9b7fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_dynameic.png
// module id = 1803
// module chunks = 0 1